import { createFileRoute } from "@tanstack/react-router";
import ExistingPatientsEs from "@/pages/es/ExistingPatientsEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/existing-patients`;

export const Route = createFileRoute("/es/existing-patients")({
  head: () => ({
    meta: [
      {
        title: "Pacientes Existentes | Neuro Wellness TMS",
      },
      {
        name: "description",
        content:
          "¿Ya es paciente de Neuro Wellness? Solicite una verificación de beneficios gratuita y deje que programemos su próxima visita o comencemos su curso de.",
      },
      {
        property: "og:title",
        content: "Pacientes Existentes | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "¿Ya es paciente de Neuro Wellness? Solicite una verificación de beneficios gratuita y deje que programemos su próxima visita o comencemos su curso de.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content:
          "Pacientes existentes: verificación de beneficios y programación | Neuro Wellness",
      },
      {
        name: "twitter:description",
        content:
          "¿Ya es paciente de Neuro Wellness? Solicite una verificación de beneficios gratuita y deje que programemos su próxima visita o comencemos su curso de tratamiento.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/existing-patients"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <ExistingPatientsEs />;
}
